import { BillingEndpoint } from './billing.endpoint';
import { InventoryEndpoint } from './inventory.endpoints';
import { LinksEndpoint } from './links.endpoints';
import { NotificationsEndpoint } from './notifications.endpoint';
import { NotificationsPageEndpoint } from './notifications-page.endpoint';
import { PublishersEndpoint } from './publishers.endpoints';
import { UsersEndpoint } from './users.endpoint';

const endpoints = {
	users: new UsersEndpoint(),
	publishers: new PublishersEndpoint(),
	inventory: new InventoryEndpoint(),
	links: new LinksEndpoint(),
	billing: new BillingEndpoint(),
	notifications: new NotificationsEndpoint(),
	notificationsPage: new NotificationsPageEndpoint(),
};

export default endpoints;
